"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(number, index) {
    return [
        ['poco fa', 'fra poco'],
        ['%s secondi fa', 'fra %s secondi'],
        ['un minuto fa', 'fra un minuto'],
        ['%s minuti fa', 'fra %s minuti'],
        ["un'ora fa", "fra un'ora"],
        ['%s ore fa', 'fra %s ore'],
        ['un giorno fa', 'fra un giorno'],
        ['%s giorni fa', 'fra %s giorni'],
        ['una settimana fa', 'fra una settimana'],
        ['%s settimane fa', 'fra %s settimane'],
        ['un mese fa', 'fra un mese'],
        ['%s mesi fa', 'fra %s mesi'],
        ['un anno fa', 'fra un anno'],
        ['%s anni fa', 'fra %s anni'],
    ][index];
}
exports.default = default_1;
//# sourceMappingURL=it.js.map